export default "__VITE_ASSET__CO1th4DS__"